import { IEventsFilters } from '@sdk/contracts';
import { dateProvider } from '@utils';
import { create } from 'zustand';

const INITIAL_FILTERS: IEventsFilters = {
  month: dateProvider.now().getMonth(),
  year: dateProvider.now().getFullYear()
};

type IStore = {
  filters: IEventsFilters;
  setFilters: (filter?: IEventsFilters) => void;
  resetFilters: () => void;
};

export const useEventFilters = create<IStore>(set => ({
  filters: INITIAL_FILTERS,
  setFilters: filters => set({ filters }),
  resetFilters: () => set({ filters: INITIAL_FILTERS })
}));
